import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/clerk';
import { api } from '../../api/client';
import {
  captureFirstTouch,
  markPosted,
  readFirstTouch,
  wasPosted,
} from '../../auth/firstTouch';

/**
 * Keeps the first landing through the sign-up flow, then saves it once.
 */
function SignupAttribution() {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  useEffect(() => {
    captureFirstTouch({
      search: location.search,
      referrer: document.referrer,
      origin: window.location.origin,
    });
  }, [location.search]);

  useEffect(() => {
    if (!isLoaded || !isSignedIn) return undefined;
    const touch = readFirstTouch();
    if (!touch || wasPosted(touch)) return undefined;
    let cancelled = false;
    (async () => {
      try {
        await api.post('/users/me/signup-source', {
          utm_source: touch.utm_source,
          utm_medium: touch.utm_medium,
          utm_campaign: touch.utm_campaign,
          referrer: touch.referrer,
          invite_token: touch.invite,
        });
        if (!cancelled) markPosted(touch);
      } catch {
        // The next signed-in load tries again. A saved first touch is not overwritten.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isLoaded, isSignedIn, location.search]);

  return null;
}

export default SignupAttribution;
